import { Action } from "redux";
import { SearchContext } from "../Models/SearchContext";

interface ISearchContextAction extends Action {
  type: SearchContextActionType;
  payload: any;
}

// ARGUMENT TYPES
export interface ISetSelectedSearchContextArguments {
  searchContext: SearchContext;
}

// PAYLOAD TYPES
export interface ISetSelectedSearchContextPayload {
  searchContext: SearchContext;
}

// ACTION TYPES
export interface ISetSelectedSearchContextAction extends ISearchContextAction {
  payload: ISetSelectedSearchContextPayload;
}

// union of all action types. If you define a new action type, add it here s'il vous plait
export type SearchContextAction = ISetSelectedSearchContextAction;

export enum SearchContextActionType {
  SEARCH_CONTEXT_SET_SELECTED = "SEARCH_CONTEXT_SET_SELECTED"
}

export const setSelectedSearchContext = (
  args: ISetSelectedSearchContextArguments
): ISetSelectedSearchContextAction => ({
  type: SearchContextActionType.SEARCH_CONTEXT_SET_SELECTED,
  payload: { ...args }
});
